import React from "react";
import Smartsection from "./SmartNetworking/Smartsection";
import { Navigation } from "./Navigation/Navigation";
import "./Headersection.css";

const Headersection = () => {
  return (
    <div>
      <div className="FullContainer">
        <Navigation />
        <Smartsection />
      </div>
    </div>
  );
};

export default Headersection;
